
export function wrap(query, tag, cssclass = "") {
    for (let elem of query) {
        const newEl = document.createElement(tag);
        newEl.classList.add(cssclass);
        elem.parentElement.insertBefore(newEl, elem);
        newEl.appendChild(elem);
    }
}